import React from 'react'
import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'

import { FormLabel } from 'components'

import './textarea.scss'

const Textarea = ({ value, label, placeholder, ...props }) => {
	const id = uuidv4()

	return (
		<div className="o-textarea">
			<FormLabel text={label} htmlFor={id} />
			<textarea
				className="o-textarea__input"
				value={value}
				id={id}
				placeholder={placeholder}
				{...props}
			/>
		</div>
	)
}

Textarea.propTypes = {
	value: PropTypes.string,
	label: PropTypes.string,
	placeholder: PropTypes.string,
}

Textarea.defaultProps = {
	value: null,
	label: null,
	placeholder: null,
}

export default Textarea
